module.exports = __webpack_public_path__ + "staticfr/media/ventos.10e5ad88.mp4";